/* Shop by Notes — vanilla JS, no dependencies. */
(function () {
  'use strict';

  var PARAM = 'note';
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  /* ------------------------------------------------------------------
     Infinite slider. Clones the notes so the loop is seamless and moves
     the list with requestAnimationFrame so arrows and autoplay share one
     position. Returns { step(dir) } or null when the slider is off.
  ------------------------------------------------------------------ */
  function setupSlider(root, onRebuild) {
    if (root.dataset.slider !== 'true' || reduceMotion.matches) return null;

    var list = root.querySelector('[data-sbn-notes]');
    var viewport = root.querySelector('.sbn__viewport');
    if (!list || !viewport) return null;

    var originals = Array.prototype.slice.call(list.children);
    if (!originals.length) return null;

    var speed = parseInt(root.dataset.speed, 10) || 30; // px per second
    var pos = 0, half = 0, stepPx = 0;
    var tween = null, holdUntil = 0, last = 0;
    var hover = false, focus = false, visible = true;

    function build() {
      Array.prototype.slice.call(list.querySelectorAll('[data-sbn-clone]')).forEach(function (n) { n.remove(); });
      root.classList.add('is-sliding');
      list.style.transform = 'none';

      var groupW = list.getBoundingClientRect().width;
      if (!groupW) return;

      var copies = Math.max(1, Math.ceil(viewport.clientWidth / groupW));
      for (var i = 0; i < copies * 2 - 1; i++) {
        originals.forEach(function (li) {
          var clone = li.cloneNode(true);
          clone.setAttribute('data-sbn-clone', '');
          clone.setAttribute('aria-hidden', 'true');
          clone.removeAttribute('data-shopify-editor-block');
          Array.prototype.forEach.call(clone.querySelectorAll('button, a'), function (el) {
            el.setAttribute('tabindex', '-1');
          });
          list.appendChild(clone);
        });
      }

      half = groupW * copies;
      var first = originals[0];
      stepPx = first.offsetWidth + (parseFloat(getComputedStyle(first).marginRight) || 0);
      pos = half ? ((pos % half) + half) % half : 0;
      if (onRebuild) onRebuild();
    }

    function frame(t) {
      if (!root.isConnected) return; // section was re-rendered in the editor
      requestAnimationFrame(frame);

      var dt = Math.min((t - last) / 1000, 0.1);
      last = t;
      if (!half || !visible) return;

      if (tween) {
        var k = Math.min((t - tween.start) / tween.dur, 1);
        pos = tween.from + (tween.to - tween.from) * (1 - Math.pow(1 - k, 3));
        if (k >= 1) tween = null;
      } else if (!hover && !focus && t > holdUntil) {
        pos += speed * dt;
      }

      var shown = ((pos % half) + half) % half;
      if (!tween) pos = shown;
      list.style.transform = 'translate3d(' + (-shown) + 'px,0,0)';
    }

    build();
    requestAnimationFrame(function (t) { last = t; frame(t); });

    // Pause on hover, keyboard focus, touch and while off-screen.
    viewport.addEventListener('mouseenter', function () { hover = true; });
    viewport.addEventListener('mouseleave', function () { hover = false; });
    list.addEventListener('focusin', function (e) {
      focus = !!(e.target.matches && e.target.matches(':focus-visible'));
    });
    list.addEventListener('focusout', function () { focus = false; });
    viewport.addEventListener('touchstart', function () {
      holdUntil = performance.now() + 3000;
    }, { passive: true });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        visible = entries[0].isIntersecting;
      }).observe(root);
    }

    var lastW = window.innerWidth, timer = null;
    window.addEventListener('resize', function () {
      if (!root.isConnected || window.innerWidth === lastW) return;
      lastW = window.innerWidth;
      clearTimeout(timer);
      timer = setTimeout(build, 250);
    });

    return {
      step: function (dir) {
        var now = performance.now();
        var base = tween ? tween.to : pos;
        tween = { from: pos, to: base + dir * stepPx, start: now, dur: 450 };
        holdUntil = now + 2500;
      }
    };
  }

  /* ------------------------------------------------------------------
     Arrows: drive the slider, or scroll the row when the slider is off.
  ------------------------------------------------------------------ */
  function setupArrows(root, slider) {
    var prev = root.querySelector('[data-sbn-prev]');
    var next = root.querySelector('[data-sbn-next]');
    var list = root.querySelector('[data-sbn-notes]');
    if (!prev || !next || !list || root.dataset.arrows !== 'true') return;

    function refresh() {
      var show = slider ? true : list.scrollWidth > list.clientWidth + 4;
      prev.hidden = next.hidden = !show;
    }

    function go(dir) {
      if (slider) {
        slider.step(dir);
      } else {
        list.scrollBy({
          left: dir * Math.max(160, list.clientWidth * 0.7),
          behavior: reduceMotion.matches ? 'auto' : 'smooth'
        });
      }
    }

    prev.addEventListener('click', function () { go(-1); });
    next.addEventListener('click', function () { go(1); });
    window.addEventListener('resize', refresh);
    refresh();
  }

  function init(root) {
    if (!root || root.dataset.sbnReady === 'true') return;
    root.dataset.sbnReady = 'true';

    var slider = setupSlider(root, function () { setButtons(active); });
    setupArrows(root, slider);

    var max = parseInt(root.dataset.max, 10) || 8;
    var defaultTitle = root.dataset.defaultTitle || '';
    var suffix = root.dataset.titleSuffix || 'Fragrances';
    var grid = root.querySelector('[data-sbn-grid]');
    var titleEl = root.querySelector('[data-sbn-title]');
    var emptyEl = root.querySelector('[data-sbn-empty]');
    var cards = grid ? Array.prototype.slice.call(grid.querySelectorAll('[data-sbn-product]')) : [];
    var active = '';
    var timer = null;

    var tokens = cards.map(function (card) {
      return (card.getAttribute('data-notes') || '').split(/[\s,|]+/).filter(Boolean);
    });

    function noteButtons() {
      return Array.prototype.slice.call(root.querySelectorAll('[data-sbn-note]'));
    }

    function render(slug, name) {
      var shown = 0;
      cards.forEach(function (card, i) {
        var match = !slug || tokens[i].indexOf(slug) !== -1;
        var visible = match && shown < max;
        if (match) shown++;
        card.hidden = !visible;
        if (visible) {
          // Images inside previously hidden cards must load right away.
          Array.prototype.forEach.call(card.querySelectorAll('img[loading="lazy"]'), function (img) {
            img.loading = 'eager';
          });
        }
      });

      if (grid) grid.hidden = slug ? shown === 0 : false;
      if (emptyEl) emptyEl.hidden = !(slug && shown === 0);
      if (titleEl) titleEl.textContent = slug ? name + ' ' + suffix : defaultTitle;
    }

    function setButtons(slug) {
      noteButtons().forEach(function (btn) {
        btn.setAttribute('aria-pressed', btn.getAttribute('data-sbn-note') === slug ? 'true' : 'false');
      });
    }

    function updateUrl(slug) {
      try {
        var url = new URL(window.location.href);
        if (slug) url.searchParams.set(PARAM, slug);
        else url.searchParams.delete(PARAM);
        window.history.replaceState(window.history.state, '', url.toString());
      } catch (e) { /* URL state is optional */ }
    }

    function apply(slug, opts) {
      opts = opts || {};
      var btn = noteButtons().filter(function (n) { return n.getAttribute('data-sbn-note') === slug; })[0];
      if (slug && !btn) slug = ''; // unknown note in URL: ignore
      var name = btn ? btn.getAttribute('data-note-name') : '';
      active = slug;
      setButtons(slug);
      if (opts.url !== false) updateUrl(slug);

      if (!grid || opts.instant || reduceMotion.matches) {
        render(slug, name);
      } else {
        // Hold the grid height during the swap so the page never jumps.
        grid.style.minHeight = grid.offsetHeight + 'px';
        grid.classList.add('is-updating');
        clearTimeout(timer);
        timer = setTimeout(function () {
          render(slug, name);
          grid.classList.remove('is-updating');
          setTimeout(function () { grid.style.minHeight = ''; }, 320);
        }, 200);
      }

      if (btn && opts.scrollNote && !root.classList.contains('is-sliding')) {
        btn.scrollIntoView({
          inline: 'center',
          block: 'nearest',
          behavior: reduceMotion.matches ? 'auto' : 'smooth'
        });
      }
    }

    // Cloned notes are aria-hidden, so they must never keep keyboard focus.
    root.addEventListener('mousedown', function (e) {
      if (e.target.closest('[data-sbn-clone]')) e.preventDefault();
    });

    root.addEventListener('click', function (e) {
      var noteBtn = e.target.closest('[data-sbn-note]');
      if (noteBtn && root.contains(noteBtn)) {
        e.preventDefault();
        if (noteBtn.closest('[data-sbn-clone]') && document.activeElement && document.activeElement.blur) {
          document.activeElement.blur();
        }
        var slug = noteBtn.getAttribute('data-sbn-note');
        if (slug === active) return; // already selected: keep the filter as is
        apply(slug, { scrollNote: true });
        return;
      }

      if (e.target.closest('[data-sbn-reset]')) {
        apply('', { scrollNote: false });
        return;
      }

      var qa = e.target.closest('[data-sbn-quick-add]');
      if (qa) quickAdd(qa);
    });

    var initial = '';
    try { initial = new URL(window.location.href).searchParams.get(PARAM) || ''; } catch (e) {}
    initial = initial.toLowerCase();
    if (initial) apply(initial, { instant: true, url: false, scrollNote: true });
    else setButtons('');
  }

  function quickAdd(btn) {
    var id = btn.getAttribute('data-variant-id');
    if (!id || btn.disabled) return;
    var label = btn.textContent;
    btn.disabled = true;

    fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return r.json();
      })
      .then(function () {
        btn.textContent = 'Added';
        document.dispatchEvent(new CustomEvent('sbn:cart-add', { bubbles: true }));
        setTimeout(function () { btn.textContent = label; btn.disabled = false; }, 1800);
      })
      .catch(function () {
        btn.textContent = 'Try again';
        setTimeout(function () { btn.textContent = label; btn.disabled = false; }, 1800);
      });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-sbn]').forEach(init);
  }

  initAll();

  // Theme Editor: re-initialise when the section is added or edited.
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();